var map = {
	"./1_zimmer1_1.webp": 4370,
	"./1_zimmer1_2.webp": 2019,
	"./1_zimmer1_3.webp": 6256,
	"./2_balkon1.webp": 6220,
	"./3_zimmer2_1.webp": 9,
	"./3_zimmer2_2.webp": 9292,
	"./3_zimmer2_3.webp": 2735,
	"./3_zimmer2_4.webp": 3954,
	"./4_bad_1.webp": 3117,
	"./4_bad_2.webp": 288,
	"./4_bad_3.webp": 6051,
	"./5_kueche1.webp": 5695,
	"./6_wohnzimmer1.webp": 379,
	"./6_wohnzimmer2.webp": 4090,
	"./7_wein.webp": 2026,
	"./8_veranda1.webp": 2358,
	"./8_veranda2.webp": 4695,
	"./9_parking.webp": 8925,
	"./beach-1.webp": 7188,
	"./brandinchi-1.webp": 3869,
	"./brandinchi-2.webp": 9200,
	"./garden-1.webp": 7272,
	"./horse-1.webp": 4258,
	"./sea-1.webp": 6316,
	"./sea-2.webp": 5993,
	"./umbau-1.webp": 5549,
	"./view-1.webp": 880,
	"./view-2.webp": 7930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 299;